import { render, staticRenderFns } from "./IconChevronRight.vue?vue&type=template&id=b4cf741a&scoped=true&"
import script from "./IconChevronRight.vue?vue&type=script&lang=ts&"
export * from "./IconChevronRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf741a",
  null
  
)

export default component.exports